
/**
 * colored and styled icon (according to the current color theme) 
 **/
import React from "react"
import { appConfig } from "../config.js"
import { getLog } from "../helpers/helpers.js"


const defaultIconStyle = {
    position: 'relative',
    zIndex: 1,
    padding: '0% 4%',
    color: 'chocolate',
    fontSize: '40px',
}

/**
 * 
 * @param {iconClass} - ex : "fa fa-plus-square" 
 * @returns a colored & styled icon accoridng to the current color theme
 */
export function IconStyled({ iconClass, children, style, ...restProps }) {

    const log = getLog("IconStyled")
    log("appConfig=", appConfig)

    const iconStyleFromTheme = appConfig.theme.iconStyle
    const styleFromProps = style

    // let's merge styles by order of priority
    const customStyle = {
        ...defaultIconStyle,
        ...iconStyleFromTheme,
        ...styleFromProps,
    }
    return (
        <i className={iconClass}
            style={customStyle}
            {...restProps}
        />
    )
}


